export default __webpack_public_path__ + "static/media/241.365a781b.png";